module.exports = __webpack_public_path__ + "8d1db29e30b93e172f0d2fe7af696297.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/head/ALLEYESONUS_HEAD.jpg
// module id = 613
// module chunks = 0